import React, { useMemo, useState } from 'react';

const matchesSearch = (user, search) => {
  const haystack = `${user.name || ''} ${user.role_name || ''} ${user.username || ''}`.toLowerCase();
  return haystack.includes(search.trim().toLowerCase());
};

const UserColumn = ({ title, hint, users, search, onSearch, onPick, emptyLabel }) => (
  <div className="quote-view-users-column">
    <div className="quote-view-users-column-header">
      <strong>{title}</strong>
      <span>{users.length}</span>
    </div>
    <p className="text-muted small mb-2">{hint}</p>
    <input
      type="search"
      className="form-control form-control-sm mb-2"
      placeholder="Search users"
      value={search}
      onChange={event => onSearch(event.target.value)}
      aria-label={title + ' search'}
    />
    <ul className="quote-view-users-list">
      {users.length === 0 ? (
        <li className="quote-view-users-empty">{emptyLabel}</li>
      ) : users.map(user => (
        <li key={user.id}>
          <button type="button" className="quote-view-users-item" onClick={() => onPick(user.id)}>
            <span className="quote-view-users-name">{user.name}</span>
            {user.role_name ? <span className="quote-view-users-role">{user.role_name}</span> : null}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const QuoteViewUsersField = ({ users = [], selectedIds = [], onChange, disabled = false }) => {
  const [availableSearch, setAvailableSearch] = useState('');
  const [selectedSearch, setSelectedSearch] = useState('');
  const selectedSet = useMemo(() => new Set(selectedIds.map(String)), [selectedIds]);
  const available = useMemo(
    () => users.filter(user => !selectedSet.has(String(user.id)) && matchesSearch(user, availableSearch)),
    [users, selectedSet, availableSearch]
  );
  const selected = useMemo(() => selectedIds
    .map(id => users.find(user => String(user.id) === String(id)) || { id, name: 'User #' + id })
    .filter(user => matchesSearch(user, selectedSearch)), [users, selectedIds, selectedSearch]);

  const addUser = id => {
    if (disabled || selectedSet.has(String(id))) return;
    onChange([...selectedIds.map(Number), Number(id)]);
  };
  const removeUser = id => {
    if (disabled) return;
    onChange(selectedIds.filter(value => String(value) !== String(id)).map(Number));
  };

  return (
    <fieldset className="quote-view-users border rounded p-3 mb-3" disabled={disabled}>
      <legend className="h6 mb-2">Quote visibility</legend>
      <p className="text-muted mb-3">
        Tap a user on the left to let this account see their quotes. Tap a user on the right to remove that access.
      </p>
      <div className="quote-view-users-grid">
        <UserColumn
          title="All users"
          hint="Not sharing quotes yet"
          users={available}
          search={availableSearch}
          onSearch={setAvailableSearch}
          onPick={addUser}
          emptyLabel="No users left to add"
        />
        <UserColumn
          title="Can see quotes of"
          hint="This user can view these quotes"
          users={selected}
          search={selectedSearch}
          onSearch={setSelectedSearch}
          onPick={removeUser}
          emptyLabel="No users selected"
        />
      </div>
    </fieldset>
  );
};

export default QuoteViewUsersField;
